module.exports = __webpack_public_path__ + "static/media/example-of-file-user-national-id-card.917a4af6.pdf";